export default __webpack_public_path__ + "static/media/closed_icon.2d764ffe.svg";